import styled from '@emotion/styled';
import { Box, Container } from '@mui/material';
import BackgroundImage from '../../assets/background.svg';

export const Wrapper = styled(Box)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;

  :before {
    background: url(${BackgroundImage}) no-repeat center center;
    background-size: cover;
    top: 0;
    left: 0;
    position: fixed;
    content: '';
    width: 100%;
    height: 100%;
    z-index: -1;
    will-change: transform;
  }
`;

export const MainContainer = styled(Container)`
  margin-top: 16px;
  margin-bottom: 16px;
  min-height: 80vh;
`;
